import { IPagination } from './pagination.model';

export enum FinancialSettingsEndpoints {
  CASH_REGISTERS = '/cash-registers',
}

export type TLegalType = 'fop' | 'tov';

export interface ICashRegisterCashier {
  id: string | null;
  name: string | null;
  login: string | null;
  has_pin_code: boolean;
}

export interface ICashRegister {
  id: string;
  name: string;
  number: string | null;
  fiscal_number: string | null;
  legal_type: TLegalType;
  fiscal_department: string | null;
  is_virtual: boolean;
  is_active: boolean;
  store_id: string | null;
  has_license_key: boolean;
  cashier: ICashRegisterCashier;
  created_at: string;
  updated_at: string;
}

// Payload shared by create/update. Secrets are optional: an empty value keeps
// the stored secret unchanged on the backend.
export interface ICashRegisterPayload {
  name: string;
  number?: string | null;
  fiscal_number?: string | null;
  legal_type: TLegalType;
  license_key?: string | null;
  fiscal_department?: string | null;
  is_virtual: boolean;
  is_active: boolean;
  store_id?: string | null;
  cashier_name: string;
  cashier_login: string;
  cashier_pin_code?: string | null;
}

export type ICreateCashRegisterDTO = ICashRegisterPayload;

export interface IEditCashRegisterDTO extends ICashRegisterPayload {
  id: string;
}

export interface IGetCashRegistersDTO {
  page?: number;
  limit?: number;
  name?: string;
  legal_type?: TLegalType;
  is_virtual?: boolean;
  is_active?: boolean;
}

export interface IGetCashRegistersResponse {
  data: ICashRegister[];
  meta: IPagination;
}

export interface IGetCashRegisterResponse {
  data: ICashRegister;
}
